import React from 'react';

import styled from 'styled-components';

export default function Partners() {
  return (
    <StyledPartners>
      <StyledTitle>Our Partners</StyledTitle>
      <StyledPartnersLogo
        alt="partners logo"
        src="images/Home/partners/logo/group-13@3x.png"
      />
      <StyledPartnersMobileLogo
        alt="partners mobile logo"
        src="images/Home/partners/MobileLogo/group-14@3x(new)-1.png"
      />
    </StyledPartners>
  );
}

const StyledPartners = styled.article`
  text-align: center;
`;

const StyledTitle = styled.h2`
  margin-bottom: -110px;
  padding-bottom: 30px;
  font-size: ${({ theme }) => theme.pixelToRem(50)};
  font-weight: 700;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey4};

  ${({ theme }) => theme.mobile`
    padding-bottom: 28px;
    margin-bottom: 0;

    font-size: ${({ theme }) => theme.pixelToRem(30)};
    
  `}
`;

const StyledPartnersLogo = styled.img`
  display: block;
  max-width: 2000px;
  width: 100%;
  margin: 0 auto;

  ${({ theme }) => theme.mobile`
  display: none;
`}
`;

const StyledPartnersMobileLogo = styled.img`
  display: none;
  width: 100%;

  ${({ theme }) => theme.mobile`
  display: block;
`}
`;
